import React from 'react'

function Head(props) {
    return (
        <>
            <h1 className="name">{props.name}</h1>
            <div className="contains-degree">
                <p className="batchname">{props.course}</p>
                <div className="bar-container">
                    <div className="bar"></div>
                </div>
            </div>
        </>
    )
}

export default Head
